import { Link as RouterLink, LinkProps, useLocation } from 'react-router-dom'

export const Link = (props: LinkProps) => {
  const location = useLocation()
  const shouldReplace = location.pathname == props.to

  return <RouterLink {...props} replace={shouldReplace} />
}
